<div class="rating rating-card">
  <div class="rating-body">
    <div class="top-part">
        @let textVariable = text();
        @let translationKeyVariable = translationKey();
      <p class="rating-value h1 font-weight-bold mt-2 mb-1" [class.disabled]="loading">
        <span [class.hidden]="!overStar && !rate">{{ getRateValueOrPlaceholder() }}</span>
        <span [class.d-none]="overStar || rate"><span class="h6 mr-4">{{ translationKeyVariable ? (translationKeyVariable | transloco) : textVariable }}</span></span>

      </p>
      <rating class="mb-2" [class.disabled]="loading"
        [(ngModel)]="rate" [max]="max"
        [readonly]="isReadonly || loading"
        (keyup)="confirmSelection()"
        (click)="confirmSelection()"
        (onHover)="hoveringOver($event)"
        (mouseleave)="resetStar()"
        >
      </rating>
      @if (rate && !editMode) {
        <button type="button" class="btn btn-secondary btn-sm w-100" (click)="enableEditMode()"
          [disabled]="loading">
          @if(textVariable || translationKeyVariable) {
            @if(textVariable) {
              <span class="mr-1">{{ textVariable }}</span>
            } @else if(translationKeyVariable) {
              <span class="mr-1" *transloco="let t; scope: translationScope()">{{t(translationKeyVariable)}}</span>
            }
            @if (rate) {
              <span><i class="fa-solid fa-pen"></i></span>
            }
          }
        </button>
      }
    </div>
  </div>
  <ng-template #successModal>
    <div class="modal-header alert-success">
      <h4 class="modal-title pull-left text-success">{{ 'common.thank_you' | transloco }}</h4>
      <button type="button" class="btn-close close pull-right text-success" aria-label="Close"
        (click)="modalRef?.hide()">
        <i aria-hidden="true" class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="modal-body p-4 d-flex justify-content-center align-items-center flex-column">
      <p class="font-weight-bold h5">
        <span>{{ ('social.' + ratingFeedbackTranslationKey) | transloco }}</span>
      </p>

      <p class="font-weight-bold display-4 text-success">
        {{rate}}
      </p>
      <div class="d-flex flex-row align-items-center">
        <i [class]="getStarClass(0)"></i>
        <i [class]="getStarClass(1)"></i>
        <i [class]="getStarClass(2)"></i>
        <i [class]="getStarClass(3)"></i>
        <i [class]="getStarClass(4)"></i>
      </div>
    </div>
  </ng-template>
</div>